import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WAccordion: IClientComponentDefinition = {
  name: 'WAccordion',
  load: () => import(/* webpackChunkName: 'WAccordion' */ './index'),
}
